export const BASE_URL = import.meta.env.VITE_API_LINK || ''
export const FILES_LINK =
  (import.meta.env.VITE_API_LINK || '') + '/api/v1/files'
